import { Facebook, Instagram, Linkedin, Share2, Link2 } from "lucide-react";
import { useState } from "react";

// Official X (Twitter) logo as inline SVG (lucide's Twitter is the old bird)
export const XIcon = ({ size = 16, className = "" }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={className} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

// Compact inline share row used inside article thumbnails / lists
export function ShareRow({ title = "", size = "sm", testid = "share", url }) {
  const [copied, setCopied] = useState(false);
  const share = (net, e) => {
    e.preventDefault();
    e.stopPropagation();
    const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
    const t = encodeURIComponent(title);
    const u = encodeURIComponent(shareUrl);
    let target = "#";
    if (net === "x") target = `https://twitter.com/intent/tweet?text=${t}&url=${u}`;
    if (net === "fb") target = `https://www.facebook.com/sharer/sharer.php?u=${u}`;
    if (net === "in") target = `https://www.linkedin.com/sharing/share-offsite/?url=${u}`;
    if (net === "ig") target = `https://www.instagram.com/`;
    if (net === "copy") {
      if (navigator.clipboard) navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
      return;
    }
    window.open(target, "_blank", "noopener,noreferrer");
  };

  const iconSize = size === "lg" ? 16 : 13;
  const btn =
    size === "lg"
      ? "w-9 h-9 border border-[#0F0F0F]/20 hover:bg-[#0F0F0F] hover:text-white"
      : "w-7 h-7 border border-[#0F0F0F]/15 hover:bg-[#0F0F0F] hover:text-white";

  return (
    <div className="flex items-center gap-1.5" onClick={(e) => e.stopPropagation()}>
      <span className="font-sans-dev text-[10px] tracking-[0.24em] uppercase text-[#4A4A4A] mr-1">
        शेयर
      </span>
      <button data-testid={`${testid}-x`} onClick={(e) => share("x", e)} aria-label="X (Twitter)"
        className={`${btn} flex items-center justify-center rounded-full transition-colors`}>
        <XIcon size={iconSize} />
      </button>
      <button data-testid={`${testid}-fb`} onClick={(e) => share("fb", e)} aria-label="Facebook"
        className={`${btn} flex items-center justify-center rounded-full transition-colors`}>
        <Facebook size={iconSize} />
      </button>
      <button data-testid={`${testid}-ig`} onClick={(e) => share("ig", e)} aria-label="Instagram"
        className={`${btn} flex items-center justify-center rounded-full transition-colors`}>
        <Instagram size={iconSize} />
      </button>
      <button data-testid={`${testid}-in`} onClick={(e) => share("in", e)} aria-label="LinkedIn"
        className={`${btn} flex items-center justify-center rounded-full transition-colors`}>
        <Linkedin size={iconSize} />
      </button>
      <button data-testid={`${testid}-copy`} onClick={(e) => share("copy", e)} aria-label="लिंक कॉपी"
        className={`${btn} flex items-center justify-center rounded-full transition-colors relative`}>
        <Link2 size={iconSize} />
        {copied && (
          <span className="absolute -top-7 right-0 text-[10px] bg-[#0F0F0F] text-white px-2 py-0.5 rounded whitespace-nowrap">
            कॉपी!
          </span>
        )}
      </button>
    </div>
  );
}

// Larger circular share cluster for dark backgrounds
export function ShareRowDark({ title = "", testid = "share-dark", url }) {
  const share = (net, e) => {
    e.preventDefault();
    e.stopPropagation();
    const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
    const t = encodeURIComponent(title);
    const u = encodeURIComponent(shareUrl);
    let target = "#";
    if (net === "x") target = `https://twitter.com/intent/tweet?text=${t}&url=${u}`;
    if (net === "fb") target = `https://www.facebook.com/sharer/sharer.php?u=${u}`;
    if (net === "in") target = `https://www.linkedin.com/sharing/share-offsite/?url=${u}`;
    if (net === "ig") target = `https://www.instagram.com/`;
    window.open(target, "_blank", "noopener,noreferrer");
  };
  const btn = "w-9 h-9 border border-white/25 hover:bg-white hover:text-[#0A0A0A]";
  return (
    <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
      <span className="font-sans-dev text-[10px] tracking-[0.24em] uppercase text-white/60 mr-1">
        <Share2 size={12} className="inline mr-1" /> शेयर
      </span>
      <button data-testid={`${testid}-x`} onClick={(e) => share("x", e)} className={`${btn} flex items-center justify-center rounded-full transition-colors`}><XIcon size={14} /></button>
      <button data-testid={`${testid}-fb`} onClick={(e) => share("fb", e)} className={`${btn} flex items-center justify-center rounded-full transition-colors`}><Facebook size={14} /></button>
      <button data-testid={`${testid}-ig`} onClick={(e) => share("ig", e)} className={`${btn} flex items-center justify-center rounded-full transition-colors`}><Instagram size={14} /></button>
      <button data-testid={`${testid}-in`} onClick={(e) => share("in", e)} className={`${btn} flex items-center justify-center rounded-full transition-colors`}><Linkedin size={14} /></button>
    </div>
  );
}
